<template>
    <div>
        <PageTitle :title="footer.tipo == 2 ? $t('eventos.title') : (teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? $t('header.partidos_temporada', {temporada: lista_abonados.nombre}) : $t('header.partidos_titulo', {titulo: lista_abonados.nombre}))"/>
        <FirstBanner/>

        <ListadoEventosClubs 
            v-if="footer.tipo == 1" 
            :eventos="events" 
            :loading="loadingEvents"
        />

        <template v-if="footer.tipo == 2">
            <div class="container mt-2">
                <SearchEvents
                    :placeholder="$t('teatros.buscar_placeholder')"
                    :teatro="teatro.hash_teatro"
                    @search-events="getEventos"
                />
            </div>

            <ListadoEventosImagen
                :eventos="events"
                :loading="loadingEvents"
            />
        </template>

        <template v-if="events.length == 0 && !loadingEvents">
            <NoEvents/>
        </template>
    </div>
</template>

<script setup>
    import { useHead } from '@/composables/common/seo/useHead'
    import { useRouter } from '@/composables/common/router/useRouter'
    import store from '@/store'
    import { computed, ref, onMounted } from 'vue'
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import ListadoEventosClubs from '@/components/frontend/events/listado/ListadoEventosClubs';
    import NoEvents from '@/components/frontend/events/listado/NoEvents';
    import ListadoEventosImagen from '@/components/frontend/events/listado/ListadoEventosImagen';
    import SearchEvents from '@/components/frontend/events/SearchEvents'

    useHead('Eventos')

    const loadingEvents = ref(false);
    const router = useRouter();

    function getEventos(search = '') {
        let params = {
            filters : {
                search: search
            }
        };

        loadingEvents.value = true;
        store.dispatch('FRONT_EVENTS_INDEX', params).catch(error => {
            router.push({name: "front.error", params: {error: "getEventos"}});
            console.log(error);
        }).finally(() => {
            loadingEvents.value = false;
        });
    }

    onMounted(() => {
        if(store.getters.getFrontEvents === null) {
            getEventos();
        }        
    });

    const teatro = computed(() => store.getters.getTeatro)
    const footer = computed(() => store.getters.getFooter)
    const lista_abonados = computed(() => store.getters.getListaAbonados)
    const events = computed(() => {
        return store.getters.getFrontEvents?.data ? store.getters.getFrontEvents.data : [] 
    })

</script>